import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, Observable, throwError } from "rxjs";

@Injectable()
export class ChatErrorInterceptor implements HttpInterceptor {

    constructor(
        private _router: Router
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                const statusEsperado = error.status === 400 || error.status === 401;

                if (error.status >= 400 && error.status < 500 && !statusEsperado) {
                    this._router.navigate(['/empty-state']);
                }
                return throwError(() => error);
            })
        );
    }
}